import { useRef } from "react";

import style from "./style.module.scss";
import Month from "../month";
import themes from "../themes";
import { Layout } from "../layout";
import layouts from "../layout/layouts";
import { ArrowSelector } from "../../../../ui";
import { useWidth } from "../../../../hooks";
import { stripPhotoTransforms } from "../../../../media/utils/photo-transform";
import type { CalendarOptions, PageOptions } from "../../../types";

interface PageProps {
  options: CalendarOptions;
  page?: PageOptions;
  index: number;
  onChange: (page: PageOptions) => void;
  productId?: string;
  userId?: string;
  isPreview?: boolean;
}

function Page({ options, page = {}, index, onChange, productId, userId, isPreview }: PageProps) {
  const { layout: layoutKey = "margin" } = page;
  const onChangeLayout = (layout: string) => {
    // Reset photo transforms when layout changes since aspect ratios are different
    const photos = stripPhotoTransforms(page.photos);
    onChange({ ...page, layout, photos });
  };
  const onChangeDates = (dates: Record<number, string>) => onChange({ ...page, dates });
  const layoutContainer = useRef<HTMLDivElement>(null);
  const height = useWidth(layoutContainer, 0.77);
  const selectedTheme = themes.find((theme) => theme.value === options.theme) || themes[0];
  const color = options.color ? options.color : selectedTheme ? selectedTheme.color : null;

  return (
    <div className={style.container} key={index}>
      {!isPreview && (
        <div className={style.config}>
          <ArrowSelector
            options={layouts}
            value={layoutKey}
            onChange={onChangeLayout}
            renderLabel={(label) => `Format : ${label}`}
            classNames={{
              label: style.layoutLabel,
            }}
          />
        </div>
      )}
      <div className={style.layout} ref={layoutContainer} style={{ height: height ?? undefined }}>
        <Layout
          page={page}
          onChange={onChange}
          productId={productId}
          userId={userId}
          isPreview={isPreview}
        />
      </div>
      <div className={style.month} style={{ height: height ?? undefined }}>
        <Month
          month={index}
          year={options.year || 2026}
          color={color}
          dates={page.dates || {}}
          onChange={onChangeDates}
          isPreview={isPreview}
        />
      </div>
    </div>
  );
}

export default Page;
